import React from 'react';
import { Pressable, View } from 'react-native';
import { twMerge } from 'tailwind-merge';

import { useListItemPosition } from '../ListContainer';

export type ListItemPropsType = {
  pressable?: boolean;
  onPress?: () => void;
  children: React.ReactNode;
  className?: string;
};

const borders = {
  top: 'rounded-tr-2xl rounded-tl-2xl',
  bottom: 'rounded-br-2xl rounded-bl-2xl',
  full: 'rounded-2xl',
};

const ListItem = ({
  pressable = false,
  onPress,
  children,
  className,
}: ListItemPropsType) => {
  const position = useListItemPosition();
  const border = position !== 'middle' ? borders[position] : '';

  const styles = 'flex flex-row w-full items-center px-3 py-4 bg-neutral-800';
  const pressableStyles =
    'group hover:bg-list-hover active:bg-prim-electric-blue';

  return pressable ? (
    <Pressable
      onPress={onPress}
      className={twMerge(styles, pressableStyles, border, className)}
    >
      {children}
    </Pressable>
  ) : (
    <View className={twMerge(styles, border, className)}>{children}</View>
  );
};

export default ListItem;
